
import { getCurrentInstance } from 'vue';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import cookies from 'js-cookie'
import { Context } from '@nuxt/types';
import { v4 as uuidv4 } from 'uuid';
import { bucketKwaiMe } from './common-params';
dayjs.extend(utc);

export const getQuery = function () {
  let url = '';
  if (typeof window !== 'undefined') {
    url = location.search;// 获取url中"?"符后的字串
  }
  const theRequest = Object.create({});
  if (url.includes('?')) {
    const str = url.substr(1);
    const strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
    }
  }
  return theRequest;
};

export function toFixedWithOutRounding(val: number, n: number = 1) {
  const re = new RegExp(`^\\d+(?:\\.\\d{0,${n}})?`);

  return Number(val.toString().match(re));
}
// <10000 正常展示  10000<=x <1000000    >= 100万 m单位  10亿 b 不四舍五入
export function formateNum(num: number, fixedNumber?: number) {
  if (num >= 1000000000) {
    return toFixedWithOutRounding(num / 1000000000, fixedNumber) + 'B';
  }
  if (num >= 1000000) {
    return toFixedWithOutRounding(num / 1000000, fixedNumber) + 'M';
  }
  if (num >= 1000) {
    return toFixedWithOutRounding(num / 1000, fixedNumber) + 'K';
  }
  return num || 0;
}
// 带四舍五入的
export function roundingNum(num: number, reserveNum = 2, toFixedNumber = 1) {
  if (num >= 1000000000) {
    return Number(toFixedWithOutRounding(num / 1000000000, reserveNum).toFixed(toFixedNumber)) + 'B';
  }
  if (num >= 1000000) {
    return Number(toFixedWithOutRounding(num / 1000000, reserveNum).toFixed(toFixedNumber)) + 'M';
  }
  if (num >= 1000) {
    return Number(toFixedWithOutRounding(num / 1000, reserveNum).toFixed(toFixedNumber)) + 'K';
  }
  return num || 0;
}


/**
 * 
 * @param time
 * 	○ 小于发布时间60s以内：Just now
		○ 距离时间1min-60min：展示 ${0}m ago
		○ 距发布时间1h-24h：展示 ${0}h ago
		○ 距发布时间1d-7d：展示 ${0}d ago
		○ 距发布时间7日及以上且同年的：展示日期，格式为mm-dd
		○ 距发布时间7日及以上且不同年的：展示评论日期，格式为yyyy-mm-dd

 */
export function formateTime(time: string| number) {
  const { proxy } = getCurrentInstance() as { proxy: any }

  const dateTimeStamp = new Date(time).getTime()
  
	const dayC = dayjs().diff(dayjs(dateTimeStamp), 'day');
  const hourC = dayjs().diff(dayjs(dateTimeStamp), 'hour');
	const minC = dayjs().diff(dayjs(dateTimeStamp), 'minute');
  const yearC = dayjs().diff(dayjs(dateTimeStamp), 'year');

  if(minC < 1) return proxy.$root.$t('k_430982');
  if(minC >=1 && minC < 60 ) return proxy.$root.$t('k_430656').replace('${0}', Math.floor(minC));
  if(hourC >=1 && hourC < 24 ) return proxy.$root.$t('k_430655').replace('${0}', Math.floor(hourC));
  if(dayC >=1 && dayC <= 7) return proxy.$root.$t('k_430983').replace('${0}', Math.floor(dayC));
  if(yearC === 0) return dayjs(Number(dateTimeStamp)).format('DD-MM');
  return dayjs(Number(dateTimeStamp)).format('DD-MM-YYYY');
}

export function getNetworkType() {
  const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection || '';
  return connection?.type || connection?.effectiveType;
}

// 需要node client 都用
export const getUrlKwaiId = (ctx?: Context) => {
  if (!process.server) {
    let uerName
    if (typeof window !== 'undefined') {
      uerName = window.location.href.match(/@(.*?)(\/|\?|$)/)
    }
    // let uerName = window.location.href.match(/@(.*?)(\/|\?|$)/)
    return uerName && `@${uerName[1]}`
  } else {
    return `@${ctx?.params?.pathMatch}`
  }
}

export function objectToCookieString(obj: Record<string, any>) {
  return Object.entries(obj)
    .map(([key, value]) => {
      // 处理布尔值，将其转换成 'true' 或 'false'
      if (typeof value === 'boolean') {
        value = value ? 'true' : 'false';
      }
      // 对于其他非字符串类型，转换成字符串
      else if (typeof value !== 'string') {
        value = String(value);
      }
      // 对于字符串类型，需要进行编码
      value = encodeURIComponent(value);

      return `${encodeURIComponent(key)}=${value}`;
    })
    .join('; ');
}

export const getMilSeconds = (min: number) => {
  return min * 60 * 1000;
};

export const checkSeoReferrer = () => {
  let r = /google/g;
  const fReferrer = sessionStorage.getItem('fReferrer')?.toLocaleLowerCase() || ''
  return r.test(fReferrer)
}

// 将http转换称https
export const formatUrls = function (url: string) {
  const regex = /(http):\/\/(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})/;
  if (url?.startsWith('http:') && regex.test(url)) {
    // radarLog({
    //   name: 'HTTP_IP_URLS',
    //   event_type: 'pwa',
    //   category: 'KWAI_SHARE',
    //   message: `${url}`,
    //   src: window.location.pathname,
    // });
    return url
  }
  if (url?.startsWith('http:')) {
    return url.replace(/http:/, 'https:');
  }
  return url;
};

export const checkSnack = (ctx?: Context) => {
  let host
  if (process.server) {
    host = ctx?.req?.headers?.host || ''
  } else {
    host = window.location.host || ''
  }
  const isSnack = host.includes('snack')
  return {
    isSnack
  }
}
//判断是kwai，kwaime还是snack
export const kwaiOrSnack=(ctx?:any)=>{
  const {isSnack}=checkSnack()
  if(isSnack){
    return 'Snack'
  }else{
    let {startup:{bucket}}=ctx.$store.state
    if(bucketKwaiMe.includes(bucket)){
      return 'KwaiMe'
    }else{
      return 'Kwai'
    }
  }
}

export const generateUUID = () => {
  return uuidv4();
};

export const genWebDidAndSessionId = () => {
  let webDid = localStorage.getItem('webDid') || cookies.get('webDid');

  if (!webDid) {
    webDid = generateUUID();
    localStorage.setItem('webDid', webDid);
  }

  cookies.set('webDid', webDid, { expires: 365 })
  cookies.set('did', webDid, { expires: 365 })

  // 每次打开设置sessionId
  let sessionId:any = sessionStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = generateUUID();
    sessionStorage.setItem('sessionId', sessionId);
  }
  cookies.set('sessionId', sessionId)
  return {
    webDid,
    sessionId
  }
};

// 记录以session维度的第一次进入页面时的referrer
export const genFirstReferrer = () => {
  let fReferrer = sessionStorage.getItem('fReferrer');
  if (fReferrer) return
  fReferrer = document?.referrer || 'null'
  sessionStorage.setItem('fReferrer', fReferrer);
}

export const getReferrers = () => {
  return {
    fReferrer: sessionStorage.getItem('fReferrer'),
    referrer: document?.referrer
  }
}

export function genCheckPwaParams() {
  const { pwa_source } = getQuery();
  return {
    fullscreen: window.matchMedia('(display-mode: fullscreen)').matches,
    standalone: window.matchMedia('(display-mode: standalone)').matches,
    'minimal-ui': window.matchMedia('(display-mode: minimal-ui)').matches,
    'pwa_source': pwa_source === 'desktop'
  }
}

export const commonPvParams = ({ defaultPageSource }: { defaultPageSource: string }) => {
  const { webDid, sessionId } = genWebDidAndSessionId();
  const { pwa_source, page_source, _p } = getQuery()
  genFirstReferrer()
  const { referrer, fReferrer } = getReferrers()

  return {
    share_chain: window.location.href,
    session_id: sessionId,
    web_did: webDid,
    did: cookies.get('did'),
    pwa_source,
    page_source: page_source || defaultPageSource,
    pwa_install_source: localStorage.getItem('cachePwaSource'),
    open_mode: 'other',
    check_pwa_params: genCheckPwaParams(),
    network_type: getNetworkType(),
    anther_id: getUrlKwaiId(),
    extra_source: _p,
    referrer,
    fReferrer,
    is_kwai_tiny: 0,
  }
}

export const copyToClipboard = (text: string) => {
  if (!text) return;
  const textarea = document.createElement('textarea');
  document.body.appendChild(textarea);
  textarea.style.position = 'absolute';
  textarea.style.opacity = '0';
  // 复制的内容
  textarea.value = text;

  textarea.select();
  document.execCommand('copy', true);
  textarea.remove();

};

function formatNumber(val: number) {
  if (val < 10) {
      return '0' + val;
  }
  return val + '';
}

// 把秒转换为时长格式(视频播放时长转换)
export function formatTime(time: number) {
  const totalSeconds = Math.round(time);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return hours
      ? `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`
      : `${formatNumber(minutes)}:${formatNumber(seconds)}`;
}


export function objToQueryString(obj: Record<string, any>, isEncode: boolean) {
  if (typeof obj !== 'object') {
      return '';
  }
  const str = [];
  for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
          if(obj[p] == '') continue;
          if (isEncode) {
              str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
          } else {
              str.push(`${p}=${obj[p]}`);
          }
      }
  }
  return str.join('&');
}

export function repalacePath(path: string, params?: object) {
  const query = Object.assign({}, getQuery(), params||{})
  const querystring = objToQueryString(query, true);
  history?.replaceState(null, '', `${path}${querystring ? '?'+querystring:''}`);
}

export function handleCommentReg(content: string) {
  const emojiHtml = `<img src="https://cdn-static.kwai.net/kos/s101/nlav11312/kwai-pc/imgs/emoji/$1.png" alt="" style="width: 18px;height: 18px;vertical-align: sub">`;
  const imgHtml = `<img src="$1" alt="" class="comment-img" style="width: 100px;height: auto;display: block;margin-top: 12px" />`;
  const imgReg = /\!\[\S+\.webp\]\[\S+\]\[\S+\]\((\S+)\)/g;
  const emojiReg = /\[(big_eyes|clap|cry|grin|heart_eyes|heart|hug|joy|kiss|kkk|ok|rose|smile|sunglasses|sweat_smile|thumbsup|Prayer)\]/g;

  return content?.replace(imgReg, imgHtml)?.replace(emojiReg, emojiHtml)
}

export function handleUserReg(content: string) {
  const userHtml = `<span class='user'>$1</span>`
  const userReg = /(\@[\S\s]+?)\(O[0-9]+\)/g;

  return content?.replace(userReg, userHtml);
}

export function handleTagReg(content: string) {
  const tagHtml = `<span class="tag">$1</span>`;
  const tagReg = /(\#[^\#\s]+)/g;

  return content?.replace(tagReg, tagHtml)
}

export function isLoadMore(id: string, callback: Function) {
  const searchContent:HTMLElement = document.getElementById(id) as any;
  searchContent.onscroll = () => {
    //滚动条滚动时，距离顶部的距离
    const scrollTop = searchContent.scrollTop||document.body.scrollTop;
    //windowHeight是可视区的高度
    const windowHeight = searchContent.clientHeight || document.body.clientHeight;
    //scrollHeight是滚动条的总高度
    const scrollHeight = searchContent.scrollHeight||document.body.scrollHeight;
                          
    if (windowHeight >= scrollHeight) {
      callback()
    }
    //滚动条到底部的条件
    if(scrollTop+windowHeight+50 >= scrollHeight){
      callback()
    }   
  }
}

export function openNewWindow(path: string, target?: string, windowFeatures?: string) {
  window.open(path, '_blank', 'directories=0')
}
